import React from "react"

import styled from "styled-components"

import { borderRadius, colors, spacing } from "@izettle/otto"

import PDFImageAsset from "@/assets/PDF.png"
import PDFImageAsset2x from "@/assets/PDF@2x.png"
import PDFImageAsset3x from "@/assets/PDF@3x.png"

const Wrapper = styled.div`
  position: relative;
  margin-bottom: ${spacing.large};
`

const PDFImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: ${borderRadius.medium};
  background-color: ${colors.background.highlight};
  padding: 140px 110px;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.background.inverted};
  opacity: 0.5;
  border-radius: ${borderRadius.medium};
  width: 100%;
  height: auto;
`

const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${borderRadius.medium};
`

type PreviewImageProps = {
  imgUrl?: string
  alt?: string
  isPDF?: boolean
  showOverlay?: boolean
}

export const PreviewImage: React.FC<PreviewImageProps> = ({
  imgUrl,
  isPDF = false,
  showOverlay = false,
  alt,
}) => {
  if (isPDF) {
    return (
      <Wrapper>
        <PDFImage
          srcSet={`${PDFImageAsset},
                 ${PDFImageAsset2x} 2x,
                 ${PDFImageAsset3x} 3x`}
          alt={alt}
        />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Image src={imgUrl} alt={alt} />
      {showOverlay && <Overlay />}
    </Wrapper>
  )
}
